import React from "react";

import Carousel from "nuka-carousel";
import * as R from "ramda";

import { Box, Button, Flex } from "src/components/base";
import { ArrowInCircle } from "src/icons";
import { themeColor } from "src/styles";
import ComponentForType from "src/utils/ComponentForType";

import contentTypes from './contentTypes';
import { useMedia, theme } from "../../styles";

const AUTOPLAY_INTERVAL = 7500 // 15 seconds

const ArrowLink = ({ onClick, direction, currentImage, title, theme }) => {
  const currentTheme = currentImage.theme || theme;
  const color = themeColor(currentTheme);

  return (
    <Button
      onClick={onClick}
      p={2}
      bg="transparent"
      borderWidth={0}
      style={{
        cursor: "pointer",
      }}
      title={title}
    >
      <ArrowInCircle size={40} color={color} direction={direction} />
    </Button>
  );
};

const reversedBreakpoints = [
  ...R.reverse(theme.breakpoints).map(breakpoint => {
    return `(min-width: ${breakpoint}em)`
  }),
  '(min-width: 0)'
]

const ItemCarousel = ({ items, ...props }) => {
  const slideCount = useMedia(
    reversedBreakpoints,
    [props.itemsToShow, 3, 3, 2, 1, 1],
    props.itemsToShow
  )

  return (
    <Box my={3} mx={4}>
      <Carousel
        autoplay={false}
        autoplayInterval={AUTOPLAY_INTERVAL}
        wrapAround={true}
        renderCenterLeftControls={({ previousSlide, currentSlide }) => (
          <Box ml={-4}>
            <ArrowLink
              onClick={previousSlide}
              currentImage={items[currentSlide]}
              theme={props.theme}
              direction="left"
              title="View previous slide" />
          </Box>
        )}
        renderCenterRightControls={({ nextSlide, currentSlide }) => (
          <Box mr={-4}>
            <ArrowLink
              onClick={nextSlide}
              currentImage={items[currentSlide]}
              theme={props.theme}
              direction="right"
              title="View next slide" />
          </Box>
        )}
        renderBottomCenterControls={null}
        // width="100%"
        slidesToShow={slideCount}
      >
        {items.map(item => (
          <ComponentForType item={item} types={contentTypes} key={item.id} />
        ))}
      </Carousel>
    </Box>
  );
}

export default ItemCarousel


// WEBPACK FOOTER //
// ./src/components/ItemGroup/ItemCarousel.js